import { render, staticRenderFns } from "./ThematicPagesList.vue?vue&type=template&id=6890147b&scoped=true&"
import script from "./ThematicPagesList.vue?vue&type=script&lang=js&"
export * from "./ThematicPagesList.vue?vue&type=script&lang=js&"
import style0 from "./ThematicPagesList.vue?vue&type=style&index=0&id=6890147b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6890147b",
  null
  
)

export default component.exports